import { Component } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import "./style.scss"

class Dot extends Component {
  static propTypes = {
    color: PropTypes.string,
    onFocus: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    dot: PropTypes.object.isRequired,
    y: PropTypes.number.isRequired,
    x: PropTypes.number.isRequired,
    focused: PropTypes.object,
  }

  onMouseEnter = () => {
    const { dot, onFocus } = this.props
    onFocus(dot)
  }

  onMouseLeave = () => {
    const { onFocus } = this.props
    onFocus(null)
  }

  onDotClick = () => {
    const { onClick, dot } = this.props
    onClick(dot)
  }

  render() {
    const { y, x, dot, focused } = this.props
    return <g
      transform={`translate(${x},${y})`}
      className={classNames("dot", dot.className, { blurred: focused && focused.id !== dot.id })}
      onClick={this.onDotClick}
      onMouseEnter={this.onMouseEnter}
      onMouseLeave={this.onMouseLeave}
    >
      <circle r="8" cx="0" cy="0" style={{ fill: dot.color }} />
    </g>
  }
}

export default Dot
